<template>
    <div class="jobs-container">
        <transition name="fade" mode="out-in">
        <div class="main-jobs" v-if="!form">
            <div class="main-jobs-container container">
                <div class="description">
                    <p>{{$trans.get('jobs.text1')}}</p>
                </div>
                <div class="cards-container">
                    <div class="job-card lg:pr-6">
                        <div class="job-card-front">
                            <img class="image1" src="/img/background-career-student.png" alt="">
                            <img class="image2 hidden" src="/img/faq-background-copy-2.png" alt="">
                            <div class="text">
                                <h2>{{$trans.get('jobs.alumno')}}</h2>
                                <div class="collapse">
                                    <p class="mt-6">{{$trans.get('jobs.textalumnos')}}</p>
                                    <p class="mb-6">{{$trans.get('jobs.textalumnos2')}}</p>
                                    <button class="btn btn-primary px-6"  @click="select('alumno')">Aplicar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="job-card lg:pr-6">
                        <div class="job-card-front">
                            <img class="image1" src="/img/background-career-company.png" alt="">
                            <img class="image2 hidden" src="/img/faq-background-copy-2.png" alt="">
                            <div class="text">
                                <h2>Empresa</h2>
                                <div class="collapse">
                                    <p class="mt-6">{{$trans.get('jobs.textempresa')}}</p>
                                    <p class="mb-6">{{$trans.get('jobs.textempresa2')}}</p>
                                    <button class="btn btn-primary px-6" @click="select('empresa')">Aplicar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </transition>
        <transition name="fade" mode="out-in">
        <div class="jobs-form" v-if="form">
            <jobs-form @back="form = false" :select="choose"></jobs-form>
        </div>
        </transition>
    </div>
</template>
<script>
import JobsForm from './JobsForm';
export default {
    components:{
        JobsForm
    },
    data() {
        return {
            form:false,
            choose: ''
        }
    },
    methods: {
        gotoform(val){
            console.log(val);
        },
        select(val){
             console.log(val);
            this.choose = val;
            this.form = true
        }
    },
}
</script>
<style lang="scss">
.jobs-container{
    .jobs-form{
         background-color: #0f304d;
         color: white;
    }
    .main-jobs{
        .description{
            padding: 3rem 1rem;
            text-align: center;
            p{
                max-width: 700px;
                margin: 0 auto;
            }
            @media (min-width:1024px) {
                padding: 5rem 1rem;
            }
        }
        .cards-container{
            width: 100%;
            display: flex;
            flex-direction: column;
            padding-bottom: 3rem;

            @media (max-width:1023px) {
                .job-card{
                    width: 100%;
                    height: 100%;
                    display: block;
                    margin-bottom: 2rem;
                    &-front{
                        background-color: #0f304d;

                        img{
                            display: none;
                        }
                        .text{
                            color: white;
                            padding: 3rem 1rem;
                            text-align: center;
                        }
                    }

                }
            }
            @media (min-width:1024px) {
                flex-direction: row;

                .job-card{
                    width: 50%;
                    height: 100%;
                    display: block;


                    &-front{
                        position: relative;
                        width: 100%;
                        height: 100%;
                        transition: 0.5s;
                        background-color: #0f304d;
                        .image2{
                            visibility: hidden;
                            opacity: 0;
                            transition: 0.5s;
                        }
                        img{
                            width: 100%;
                            transition: visibility 0.3s, opacity 0.3s linear;
                        }
                        .text{
                            width: 100%;
                            padding: 3rem 1rem;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            text-align: center;
                            transition: 0.5s;
                            color: white;
                        }
                        .collapse{
                            display: none;
                        }
                        &:hover{

                            .image1{
                                visibility: hidden;
                                opacity: 0;
                            }
                            .image2{
                                visibility: visible;
                                opacity: 1;
                            }

                            h2{
                                font-size: 30px;
                            }
                            .collapse{
                                display: block;
                            }
                        }
                    }
                }
            }
        }
    }
}
.fade-enter-active {
  transition: opacity .5s
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
